import { Link} from "react-router-dom";
import React from "react";
import { Menu, MenuButton, MenuDivider, MenuGroup, MenuItem, MenuList, useDisclosure } from "@chakra-ui/react";
import {
  Container,
  Box,
  IconButton,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
} from "@chakra-ui/react";
import { Button, Modal, ModalOverlay } from "@chakra-ui/react";
import { ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";
import Login from "../Pages/Login";
import Register from "../Pages/Register";
import {Navigate} from "react-router-dom"
import {useNavigate} from "react-router-dom"

function InnerNavbar(){
  const navigate = useNavigate();

    const handleLogout=() => {
     
       navigate("/")
        
        
    }

    return(
        <>

<Container
        maxW="full"
        style={{
          paddingTop: "15px",
          paddingBottom: "15px",
          backgroundColor: "#041628",
          fontFamily: "sans-serif",
          // border : "2px solid red"
        }}
      >
        <div
          style={{
            width: "80%",
            margin: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Link path="/" to="/">
              <img
                style={{ width: "145px" }}
                src="	https://www.gymwolf.com/img/gymwolf.png"
                alt="logo"
              />
            </Link>
          </div>
          <div
            style={{
              display: "flex",
              gap: "30px",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "18px",
            }}
          >
            <Link path="/Progress" to="/Progress">
              Progress
            </Link>

            <Link path="/Register" to="/Register">
              Calculators
            </Link>

            <Link path="/Register" to="/Register">
              Exercises and Plans
            </Link>

            <Link path="/trainer" to="/trainer">
              My Personal Trainer
            </Link>

            {/* Profile Section Here */}
            <Menu>
              <MenuButton as={Button} colorScheme='none'>
                My Profile
              </MenuButton>
              <MenuList style={{color : "rgba(0, 0, 0, 0.80)" , backgroundColor : "white", marginTop:"8px"}}>
                <MenuGroup title='Profile'>
                  <MenuItem>My Account</MenuItem>
                  <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
                </MenuGroup>
                <MenuDivider style={{color: "gray"}} />
                <MenuGroup title='Help'>
                  <MenuItem>Docs</MenuItem>
                  <MenuItem>FAQ</MenuItem>
                </MenuGroup>
              </MenuList>
            </Menu>

            
            {/* Search Button */}

            <IconButton
              colorScheme="none"
              backgroundColor="none"
              color="white"
              aria-label="Search database"
              icon={<SearchIcon />}
            />
          </div>
        </div>
      </Container>
        
        </>
    )
}
export default InnerNavbar;